import { Tag } from 'antd'
import dayjs from 'dayjs'

export const getStatusColor = status => {
  switch (status) {
    case 'pending':
      return 'orange'
    case 'processing':
      return 'blue'
    case 'completed':
      return 'green'
    case 'failed':
      return 'red'
    default:
      return 'default'
  }
}

export const columns = [
  {
    title: 'Report Type',
    dataIndex: 'report_type',
    key: 'report_type',
    render: text => (
      <span className='text-capitalize'>
        {text?.replace(/([A-Z])/g, ' $1').trim()}
      </span>
    )
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    render: status => (
      <Tag color={getStatusColor(status)} className='text-uppercase'>
        {status}
      </Tag>
    )
  },
  {
    title: 'Created At',
    dataIndex: 'created_at',
    key: 'created_at',
    render: date => dayjs(date).format('YYYY-MM-DD HH:mm:ss')
  },
  {
    title: 'Completed At',
    dataIndex: 'completed_at',
    key: 'completed_at',
    render: date => (date ? dayjs(date).format('YYYY-MM-DD HH:mm:ss') : '-')
  },
  {
    title: 'File',
    dataIndex: 'download_url',
    key: 'download_url',
    render: (download_url, record) =>
      record.status === 'completed' && download_url ? (
        <a
          href={download_url}
          target='_blank'
          rel='noopener noreferrer'
          className='btn btn-outline-theme'
        >
          Download
        </a>
      ) : (
        '-'
      )
  }
]
